<template>
  <div class="verification">
    <el-button size="small" type="primary" @click="send" :nums="num" :disabled="disabled || (!enable)">{{content}}</el-button>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'verification',
  data() {
    return {
      content: i18n.t('components_verificationbutton_index_2494'),
      disabled: false,
      num: this.nums
    }
  },
  props: {
    enable: {
      type: Boolean,
      default: true
    },
    nums: {
      type: Number,
      default: 60
    },
    stop: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  watch: {
    stop(val) {
      if (!val) {
        this.disabled = true
        const timer = setInterval(() => {
          this.num--
          this.content = i18n.t('components_verificationbutton_index_2495', [this.num])
          if (this.num === 0) {
            this.num = this.nums
            this.disabled = false
            this.content = i18n.t('components_verificationbutton_index_2496')
            clearInterval(timer)
          }
        }, 1000)
      }
    }
  },
  methods: {
    setContent(val) {
      this.content = val
    },
    send() {
      this.$emit('send')
    }
  }
}

</script>
<style lang='scss' scoped>
.verification{
  display: inline-block;
  .el-button{
    width: 130px;
    margin-left: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/verificationButton/index.vue